import type { ChartRecommendation } from '../../../types';
import { CHART_STYLE } from './chartStyles';

interface ChartContainerProps {
  recommendation: ChartRecommendation;
  children: React.ReactNode;
}

const CHART_LABELS: Record<string, string> = {
  bar: 'Bar Chart',
  stacked_bar: 'Stacked Bar Chart',
  line: 'Line Chart',
  multi_line: 'Multi-Line Chart',
  donut: 'Donut Chart',
  scatter: 'Scatter Plot',
  bubble: 'Bubble Chart',
  histogram: 'Histogram',
  box_plot: 'Box Plot',
  area_volume: 'Area + Volume',
  candlestick: 'Candlestick',
  kpi_card: 'Metric Card',
  table: 'Table',
};

/**
 * Responsive wrapper for ERAX charts. Adds a subtle rule badge at the bottom.
 */
export function ChartContainer({ recommendation, children }: ChartContainerProps) {
  const label = CHART_LABELS[recommendation.chartType] ?? recommendation.chartType;

  return (
    <div className="mt-2 rounded-lg bg-white border border-gray-200 p-1 overflow-hidden flex flex-col items-center">
      <div className={`flex-1 w-full h-full flex items-center justify-center ${
        recommendation.chartType === 'kpi_card' ? 'min-h-[120px]' : 'min-h-[350px]'
      }`}>
        {children}
      </div>
      <div className="flex items-center gap-1.5 mt-0.5 px-0.5">
        <span
          className="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] bg-indigo-50 text-indigo-600 font-medium"
        >
          {label}
        </span>
        <span className="text-[9px] text-gray-400">
          Rule {recommendation.matchedRule}
        </span>
      </div>
    </div>
  );
}
